import { Injectable } from '@angular/core';
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
  NormalizedCacheObject
} from '@apollo/client/core';
import { setContext, SetContextLink } from '@apollo/client/link/context';
import { from, Subject } from 'rxjs';
import { GET_HOME_BUILDING_FACILITIES, GET_ORDERS } from 'src/app/shared/graph-queries/core-data.queries';
import { CoreFacility } from 'src/app/shared/models/core-facility.model';
import { CoreOrder } from 'src/app/shared/models/core-order.model';
import { TokenClaimsService, UrlBuilderService } from 'src/app/shared/services';

@Injectable({
  providedIn: 'root',
})
export class CoreDataService {
  coreFacilities$ = new Subject<CoreFacility[]>();
  coreOrders$ = new Subject<CoreOrder[]>();
  private apolloClient: ApolloClient;

  constructor(
    private claimsService: TokenClaimsService,
    private urlBuilder: UrlBuilderService
  ) {

    const CORE_URL = this.urlBuilder.generateCoreDataGraphUrl();
    const httpLink = new HttpLink({ uri: CORE_URL });
    const token = this.claimsService.getIdToken();

    const authLink = new SetContextLink((prevContext: any) => {

      return {
        headers: {
          ...prevContext.headers,
          authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      };
    });


    this.apolloClient = new ApolloClient({
      link: ApolloLink.from([authLink, httpLink]),
      cache: new InMemoryCache()
    });
  }

  getCoreFacilities(): void {
    from(this.apolloClient.query({ query: GET_HOME_BUILDING_FACILITIES })).subscribe({
      next: (response: any) => {
        const result = response.data?.GetCoreFacilities || [];
        this.coreFacilities$.next(result);
      },
      error: (err: any) => {
        console.error('Core Data GraphQL error', err);

        if (err.networkError) {
          console.warn('Network error details:', {
            statusCode: err.networkError.statusCode,
            bodyText: err.networkError.bodyText
          });
        }

        if (err.graphQLErrors?.length) {
          console.warn('GraphQL error details:', err.graphQLErrors);
        }
      }
    });
  }

  async getCoreOrdersByPlantNumber(facilityNumber: string): Promise<void> {
    try {
      const response: any = await this.apolloClient.query({
        query: GET_ORDERS(facilityNumber)
      });
      const result = response.data?.GetOrders || [];
      this.coreOrders$.next(result);
    } catch(err: any) {
      console.error('Core Data GraphQL Error', err);

      if (err.networkError) {
        console.warn('Network error details :', {
          statusCode: err.networkError.statusCode,
          bodyText: err.networkError.bodyText
        });
      }

      if (err.graphQLErrors?.length) {
        console.warn('GraphQL error details:', err.graphQLErrors);
      }

      this.coreOrders$.next([]);
    }
  }
}
